import { makeRequest } from 'api/apiv2'
import { message } from 'antd'
import { config } from 'configs'
import { organizationRolesActions } from './OrganizationRolesReducer'

// // We are now using options from json file rather database
// export const getRoleOptions = () => (dispatch) => {
//   dispatch(organizationRolesActions.setLoading({ fetchRoleOptions: true }))
//   makeRequest('get', `/admin/user-roles/options`)
//     .then((res) => {
//       const items = res?.results
//       if (items) {
//         dispatch(organizationRolesActions.setRoleOptions(items))
//       } else {
//         dispatch(organizationRolesActions.setRoleOptions([]))
//       }
//       dispatch(organizationRolesActions.setLoading({ fetchRoleOptions: false }))
//     })
//     .catch((error) => {
//       message.error(error?.response?.data?.error || config.defaultErrorMessage)
//       dispatch(organizationRolesActions.setRoleOptions([]))
//       dispatch(organizationRolesActions.setLoading({ fetchRoleOptions: false }))
//     })
// }

export const getOrganizationUsers = (organizationId) => (dispatch) => {
  dispatch(organizationRolesActions.setLoading({ fetchRoleList: true }))
  makeRequest('get', `/admin/user-roles/${organizationId}`)
    .then((res) => {
      const item = res?.results
      if (item) {
        dispatch(organizationRolesActions.setRoleList(item))
      } else {
        dispatch(organizationRolesActions.setRoleList([]))
      }
      dispatch(organizationRolesActions.setLoading({ fetchRoleList: false }))
    })
    .catch((error) => {
      message.error(error?.response?.data?.error || config.defaultErrorMessage)
      dispatch(organizationRolesActions.setRoleList([]))
      dispatch(organizationRolesActions.setLoading({ fetchRoleList: false }))
    })
}

export const getRole = (organizationId, userId) => (dispatch) => {
  dispatch(organizationRolesActions.setLoading({ fetchRole: true }))
  makeRequest('get', `/admin/user-roles/${organizationId}/${userId}`)
    .then((res) => {
      const item = res?.results
      if (item) {
        dispatch(organizationRolesActions.setRole(item))
      } else {
        dispatch(organizationRolesActions.setRole(null))
      }
      dispatch(organizationRolesActions.setLoading({ fetchRole: false }))
    })
    .catch((error) => {
      message.error(error?.response?.data?.error || config.defaultErrorMessage)
      dispatch(organizationRolesActions.setRole(null))
      dispatch(organizationRolesActions.setLoading({ fetchRole: false }))
    })
}

export const addRole = (payload, actions) => async (dispatch) => {
  dispatch(organizationRolesActions.setLoading({ adding: true }))
  makeRequest(
    'post',
    `/admin/user-roles/`,
    {
      organizationid: payload.OrganizationId,
    },
    payload,
  )
    .then((res) => {
      message.success(res.message || 'Role added successfully')
      dispatch(organizationRolesActions.setLoading({ adding: false }))
      if (actions) {
        actions()
      }
    })
    .catch((error) => {
      message.error(error?.response?.data?.error || config.defaultErrorMessage)
      dispatch(organizationRolesActions.setLoading({ adding: false }))
    })
}

export const updateRole = (payload) => async (dispatch) => {
  const cellName = payload?.Role
  dispatch(organizationRolesActions.setLoading({ updating: cellName }))
  makeRequest(
    'patch',
    `/admin/user-roles/${payload?.OrganizationId}/${payload?.UserId}`,
    {
      organizationid: payload.OrganizationId,
    },
    payload,
  )
    .then((res) => {
      message.success(res.message || 'Permission update successfully')
      const item = res.results
      if (item) {
        dispatch(organizationRolesActions.setRole(item))
      }
      dispatch(organizationRolesActions.setLoading({ updating: false }))
    })
    .catch((error) => {
      message.error(error?.response?.data?.error || config.defaultErrorMessage)
      dispatch(organizationRolesActions.setLoading({ updating: false }))
    })
}

export const updateRoleStatus = (payload) => async (dispatch) => {
  dispatch(organizationRolesActions.setLoading({ changingStatus: true }))
  makeRequest(
    'patch',
    `/admin/user-roles/${payload?.OrganizationId}/${payload?.UserId}/status/${payload?.Action}`,
    {
      organizationid: payload.OrganizationId,
    },
    payload,
  )
    .then((res) => {
      message.success(res.message || 'Role update successfully')
      const item = res.results
      if (item) {
        dispatch(organizationRolesActions.setRole(item))
      }
      dispatch(organizationRolesActions.setLoading({ changingStatus: false }))
    })
    .catch((error) => {
      message.error(error?.response?.data?.error || config.defaultErrorMessage)
      dispatch(organizationRolesActions.setLoading({ changingStatus: false }))
    })
}

export const deleteRole = (payload, actions) => (dispatch) => {
  dispatch(organizationRolesActions.setLoading({ deleting: true }))
  makeRequest(
    'delete',
    `/admin/user-roles/${payload?.OrganizationId}/${payload?.UserId}`,
    {
      organizationid: payload?.OrganizationId,
    },
  )
    .then((res) => {
      message.success(res.message || 'Role deleted successfully')
      dispatch(organizationRolesActions.setLoading({ deleting: false }))
      dispatch(organizationRolesActions.setRole(null))
      if (actions) {
        actions()
      }
    })
    .catch((error) => {
      message.error(error?.response?.data?.error || config.defaultErrorMessage)
      dispatch(organizationRolesActions.setLoading({ deleting: false }))
      dispatch(organizationRolesActions.setRole(null))
    })
}
